import { useEffect, useState } from 'react';
import axios from 'axios';
import { Vote } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const LABELS = { love: 'Love it', okay: "It's okay", back_to_code: 'Back to the Code' };

// Modern theme poll tallies (test/seeded accounts excluded server-side).
export function ThemePollResults() {
  const [data, setData] = useState(null);
  useEffect(() => {
    axios.get(`${API_URL}/api/admin/theme-feedback/results`, { withCredentials: true }).then((r) => setData(r.data)).catch(() => {});
  }, []);
  if (!data) return null;
  const rows = Object.entries(data.by_reaction).sort((a, b) => b[1] - a[1]);
  return (
    <section className="mb-6 bg-[#0C0612] border border-[#2A0F3D] p-5 font-mono" data-testid="theme-poll-results">
      <h2 className="text-[#BF5AF2] text-sm font-bold flex items-center gap-2"><Vote className="w-4 h-4" /> MODERN_THEME_POLL</h2>
      <p className="text-[#4B6B52] text-xs mt-1" data-testid="theme-poll-summary">
        // {data.total} real votes · {data.excluded_test} test-account vote(s) excluded · {data.modern_customers} customers on Modern
      </p>
      <ul className="mt-3 space-y-1.5">
        {rows.map(([k, n]) => (
          <li key={k} className="text-xs" data-testid={`theme-poll-${k}`}>
            <div className="flex justify-between text-[#A3C7A8]"><span>{LABELS[k] || k}</span><span>{n} · {data.total ? Math.round((n / data.total) * 100) : 0}%</span></div>
            <div className="h-1.5 bg-[#2A0F3D]"><div className="h-full bg-[#BF5AF2]" style={{ width: `${data.total ? (n / data.total) * 100 : 0}%` }} /></div>
          </li>
        ))}
      </ul>
      {Object.keys(data.by_region).length > 1 && (
        <p className="text-[10px] text-[#6B8E73] mt-2">
          {Object.entries(data.by_region).map(([r, c]) => `${r.toUpperCase()}: ${Object.values(c).reduce((a, b) => a + b, 0)}`).join(' · ')}
        </p>
      )}
    </section>
  );
}
